import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Haiti to Miami",
    accent: "blood",
    body: "Born and raised between Haiti and Miami, Ali Zo carried two worlds on his back — the pride of the first Black republic and the grind of South Florida's streets. Challenges came from every direction: law enforcement on one side, street gangs on the other.",
  },
  {
    num: "02",
    title: "The Early 90s",
    accent: "royal",
    body: "Haitian people in South Florida were bullied — by the media, by the streets, by a world that refused to say their names with respect. Being Haitian was treated like a mark against you. The community needed a shield.",
  },
  {
    num: "03",
    title: "Zo Pound Rises",
    accent: "blood",
    body: "In the late 90's, Ali Zo founded the Zo Pound movement. What outsiders called a gang became something else entirely for Haitians in Florida — a force that built trust, commanded respect, and protected its own.",
  },
  {
    num: "04",
    title: "The Experience",
    accent: "royal",
    body: "Decades later, Jean Luc picks up the microphone. THE ZO POUND EXPERIENCE is a gold mine of powerful information — highlighting the great things Haitians have contributed to the world. They deserve respect. This show makes sure they get it.",
  },
];

export default function Chapters() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="relative py-20 lg:py-32 px-4 sm:px-8 lg:px-16">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-7xl mx-auto"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-blood mb-4">The Manifesto</p>
        <h2 className="font-display font-black uppercase text-3xl sm:text-4xl lg:text-5xl tracking-tight max-w-2xl">
          Four chapters. One movement.
        </h2>
      </motion.div>

      <div className="max-w-7xl mx-auto mt-16 grid gap-8 lg:gap-12">
        {CHAPTERS.map((ch, i) => (
          <motion.article
            key={ch.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.05 * i, ease: [0.16, 1, 0.3, 1] }}
            data-testid={`manifesto-chapter-${ch.num}`}
            className={`group relative bg-surface border border-white/10 p-6 sm:p-10 grid md:grid-cols-[auto_1fr] gap-6 md:gap-12 items-start hover:border-white/25 transition-colors duration-500 ${
              i % 2 === 1 ? "md:ml-16" : "md:mr-16"
            }`}
          >
            <span
              className={`absolute top-0 left-0 h-1 w-0 group-hover:w-full transition-all duration-700 ${
                ch.accent === "blood" ? "bg-blood" : "bg-royal"
              }`}
            />
            <span className="font-display font-black text-7xl sm:text-8xl leading-none text-outline-faint select-none">
              {ch.num}
            </span>
            <div>
              <h3 className={`font-display font-bold uppercase text-2xl sm:text-3xl tracking-wide ${
                ch.accent === "blood" ? "text-blood" : "text-blue-400"
              }`}>
                {ch.title}
              </h3>
              <p className="mt-4 text-base sm:text-lg text-gray-400 leading-relaxed max-w-3xl">{ch.body}</p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
